import { XMLHttpConfig } from "../global/XMLHttpConfig";

export class HttpService {

    private xmlHttp: XMLHttpRequest;    

    public get(config: XMLHttpConfig): Promise<any> {
        return this.xhrPromise("GET", config);        
    }
    
    public post(config: XMLHttpConfig): Promise<any> {
        return this.xhrPromise("POST", config);
    }

    private xhrPromise(method: string, config: XMLHttpConfig): Promise<any> {
        return new Promise((resolve, reject) => {

            this.xmlHttp = new XMLHttpRequest();

            this.xmlHttp.open(method, config.Url);

            this.xmlHttp.onload = this.onLoad(resolve, reject);

            // reject this promise inside the standard XHR error
            this.xmlHttp.onerror = this.onError(reject);

            // set any config headers
            this.setHeaders(config.Headers, this.xmlHttp);
            // set any config parameters
            this.xmlHttp.send(this.setParams(config.Params));
        });
    }
    
    private onLoad(resolve, reject) {
        return () => {
            if (this.xmlHttp.status >= 200 && this.xmlHttp.status < 300) {
                // resolve this promise if successful
                resolve(JSON.parse(this.xmlHttp.response));
            } else {
                // else reject it 
                reject({
                    status: this.xmlHttp.status,
                    statusText: this.xmlHttp.statusText,
                });
            }
        };
    }

    private onError(reject) {
        return () => {
            reject({
                status: this.xmlHttp.status,
                statusText: this.xmlHttp.statusText,
            });
        };
    }

    private setHeaders(headers: any, xmlHttp: XMLHttpRequest) {
        if (headers) {
            Object.keys(headers).forEach((key) => {
                xmlHttp.setRequestHeader(key, headers[key]);
            });
        }
    }

    private setParams(params: any) {
        if (params && typeof params === "object") {
            params = Object.keys(params).map((key) => {
                return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
            }).join("&");
        }
        return params;
    }
}



// WEBPACK FOOTER //
// ./src/services/HttpService.ts